import React, { useEffect, useState } from 'react';

import FormBody from 'components/FormBody/index';
import FormHeader from 'components/FormHeader/index';
import { Theme } from 'enums/Theme';
import { useAppSelector } from 'hooks/useAppSelector';
import { LoadingType } from 'actions/index';
import Loader from 'components/Loader/index';
import { Lender } from 'enums/ApplicationsVariables';
import { ProgressBarStatus } from 'enums/ProgressBarStatus';
import styles from 'pages/Dashboard/AcceptedOfferDetails/AcceptedOfferDetails.module.scss';
import {
  ACCEPTED_OFFER_HEADER_TITLE,
  QUILO_FIXED_RATE_DESCRIPTION,
} from 'pages/Dashboard/steps/AcceptOffer/acceptOffer.constants';
import LoanOfferCard from 'pages/Dashboard/steps/AcceptOffer/AcceptOffer/LoanOfferCard/LoanOfferCard';
import LoanOfferOptions from 'pages/Dashboard/steps/AcceptOffer/AcceptOffer/LoanOfferOptions/LoanOfferOptions';
import { OfferDto, offersApi } from 'api/OffersApi';
import * as notificationManager from 'notifications';
import { FailureNotificationType } from 'notifications';

const AcceptedOfferDetails = () => {
  const { applicationId } = useAppSelector((state) => state.application);
  const isGlobalLoading = useAppSelector((state) => state.loading[LoadingType.DashboardPageUpdating]);
  const [loanOffers, setLoanOffers] = useState<OfferDto[]>([]);
  const [isAnyLenderQuilo, setIsAnyLenderQuilo] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getLoans = async () => {
      try {
        setIsLoading(true);

        const offersResponse = await offersApi.getOffers(applicationId!);

        setLoanOffers(offersResponse);
        setIsAnyLenderQuilo(offersResponse.map((offer) => offer.lender).includes(Lender.Quilo));
      } catch (error) {
        notificationManager.notifyFailure(FailureNotificationType.UnknownError);
      } finally {
        setIsLoading(false);
      }
    };

    getLoans();
  }, [applicationId]);

  return isLoading || isGlobalLoading ? (
    <Loader />
  ) : (
    <>
      <FormHeader
        isBorderRounded={false}
        title={ACCEPTED_OFFER_HEADER_TITLE}
        theme={Theme.Dark}
        percent={ProgressBarStatus.Done}
      ></FormHeader>
      <div className={styles.acceptOfferContainer}>
        {loanOffers && (
          <FormBody formBodyClassName={styles.formBody}>
            <div className={styles.offerCards}>
              {loanOffers.map((loanOffer, index) => {
                return (
                  <LoanOfferCard
                    key={index}
                    title={loanOffers.length > 1 ? `Loan ${index + 1}` : ``}
                    loanOffer={loanOffer}
                    lender={''}
                  />
                );
              })}
              <LoanOfferOptions />
            </div>
            {isAnyLenderQuilo && <div className={styles.fixedRateDescription}>{QUILO_FIXED_RATE_DESCRIPTION}</div>}
          </FormBody>
        )}
      </div>
    </>
  );
};

export default AcceptedOfferDetails;
